import restApiConnection from '@/services/api/providers/Connection'
import RestApiBase from '@/services/models/RestApiBase'
import myOffice from '@/types/myOffice'
import UserSession from '@/services/models/UserSession'
import { AxiosResponse } from 'axios'
import { CacheAxiosResponse } from 'axios-cache-interceptor'
import { CACHE_TTL_DEFAULT } from '@/config'

export default class MyOffice extends RestApiBase {
  public static async get(): Promise<AxiosResponse<myOffice | undefined>> {
    return this.sync('GetMyOffice', this.getOwn)
  }

  public static getOwn = async (): Promise<CacheAxiosResponse<myOffice>> => {
    const config = {
      cache: {
        ttl: CACHE_TTL_DEFAULT,
      },
      params: {
        user_session_id: UserSession.getStoredUserId(),
      },
    }

    return await restApiConnection
      .get('/my_office', config)
      .catch(async (error) => {
        console.error('API Call Failed on driver. Error:', error)
        throw error
      })
  }
}
